<!--
 * @Author: ZhengXiaowei
 * @Date: 2019-01-09 14:06:31
 * @LastEditors: 晓晓晓晓晓丶vv
 * @LastEditTime: 2020-11-24 18:06:21
 * @Description: file content
 -->
<template>
  <x-page hide-header class="reader-container">
    <div
      class="x-reader"
      :style="readerStyle"
      @click="showBgChoose && (showBgChoose = false)"
      v-if="init"
    >
      <!-- 阅读器标题 -->
      <div class="x-reader__title" :style="readerTitleLineStyle">
        <p
          :class="['title', { 'title-is_addshelf': chapter.isAddBookCase }]"
          :style="readerTitleStyle"
        >
          {{ chapterInfo.title }}
        </p>
        <p class="add">
          <span
            v-if="!chapter.isAddBookShelf"
            :style="menuStyle"
            @click="addToShelf"
            >加入书架</span
          >
          <i
            class="icon-Hxiangqing"
            :style="authorColorStyle"
            @click="back"
          ></i>
        </p>
      </div>
      <!-- 阅读器控制 -->
      <div class="x-reader__operator">
        <div class="x-reader__operator--base">
          <span class="operator-item" :style="menuStyle" @click="subtract"
            >A-</span
          >
          <span class="operator-item" :style="menuStyle" @click="add">A+</span>
          <span
            class="operator-item"
            :style="menuStyle"
            @click.stop="showBgChoose = !showBgChoose"
            >背景
            <transition name="van-fade">
              <div class="operator-item__bg" v-show="showBgChoose" @click.stop>
                <template v-for="(bg, i) in options.bgColorStyles">
                  <div
                    class="bg-item"
                    :key="i"
                    :style="{
                      background: bg.background,
                      borderColor: bg.btnBorder,
                    }"
                    @click="bgChange(i)"
                  >
                    <img
                      src="../assets/阅读器/bg_check.png"
                      class="bg_check"
                      v-show="bgIndex === i"
                    />
                  </div>
                </template>
              </div>
            </transition>
          </span>
          <span
            class="operator-item bg-item__night"
            :style="{
              background: '#666',
              borderColor: options.nightStyle.btnBorder,
            }"
            @click="toggleNight"
          >
            <img :src="night ? icon.sun : icon.night" alt="" />
          </span>
        </div>
        <div class="x-reader__operator--other">
          <!-- <span class="operator-item"
                :style="menuStyle">纠错</span> -->
          <img
            src="../assets/阅读器/send_gift.png"
            alt=""
            @click="showPopup(0)"
          />
          <!-- <span class="operator-item"
                :style="menuStyle"
                @click="demo">送礼物</span> -->
          <!-- <span class="operator-item operator-share">分享</span> -->
        </div>
      </div>
      <!-- 阅读器正文 -->
      <div class="x-reader__content" :style="readerContentStyle">
        <p class="x-reader__content--text" v-for="(c, i) in content" :key="i">
          {{ c }}
        </p>
      </div>
      <!-- 投诉入口 -->
      <p class="x-reader__report-entry">
        <i class="icon-report"></i>
        <router-link
          :to="{
            path: '/report',
            query: { bid: chapter.bid, cid: chapter.cid },
          }"
          tag="span"
          >投诉</router-link
        >
      </p>

      <!-- 引导收藏 -->
      <p
        class="subscribe-text"
        style="font-size: 0.34rem; color: #2572ff; margin: 0.4rem 0 0.2rem"
        @click.stop="showWechatCollection = true"
        v-show="wechat_float.show"
      >
        {{ wechat_float.content }}
      </p>

      <!-- 弱关 -->
      <p
        class="subscribe-text"
        style="font-size: 0.28rem; color: #379fff; margin: 0.4rem 0 0.2rem"
        @click.stop="showSubscribeQrCode"
        v-show="weakSubscribe"
      >
        {{ showRandomWeakText() }}
      </p>
      <!-- <p class="x-reader__tap">好看</p> -->
      <!-- 个人号 -->
      <p
        class="subscribe-text"
        style="font-size: 0.34rem; color: #2572ff; margin: 0.4rem 0 0.2rem"
        @click.stop="guideEntry('text')"
        v-show="guide_personal_account.title"
      >
        {{ guide_personal_account.title }}
      </p>
      <!-- 强关 -->
      <p
        class="subscribe-text"
        style="font-size: 0.28rem; color: #379fff; margin: 0.4rem 0 0.2rem"
        @click.stop="showSubscribeQrcodeInChapter(chapterInfo.tip)"
        v-show="chapterInfo.tip.show"
      >
        &gt;&gt; {{ chapterInfo.tip.content }} &lt;&lt;
      </p>
      <!-- 章节操作 -->
      <div class="x-reader__menu" @click.stop="menuOperator">
        <span
          class="x-reader__menu--item x-reader__menu--prev"
          :style="systemStyle"
          >上一章</span
        >
        <span
          class="x-reader__menu--item x-reader__menu--catalog"
          :style="systemStyle"
          >目录</span
        >
        <span
          class="x-reader__menu--item x-reader__menu--next"
          :style="systemStyle"
          >下一章<img
            v-show="hasNextRed"
            src="../assets/next-red-tag.gif"
            alt=""
        /></span>
      </div>
      <!-- 活动banner -->
      <div class="x-reader__activity" v-if="ABanner">
        <img :src="ABanner.img" alt="" @click="toActivity(ABanner.link)" />
      </div>
      <!-- 个人号banner -->
      <div class="x-reader__activity" v-if="guide_personal_account.banner">
        <img
          :src="guide_personal_account.banner"
          alt=""
          @click.stop="guideEntry('banner')"
        />
      </div>

      <!-- 作者 -->
      <div
        class="x-reader__author"
        :style="authorBoxStyle"
        v-if="chapter.author"
      >
        <p
          class="title"
          :style="[authorLineStyle, authorColorStyle]"
          v-show="chapter.author.uid && chapter.author.authorSay"
        >
          作者有话说
          <router-link
            tag="i"
            :style="authorColorStyle"
            :to="{
              name: AuthorSay,
              query: { author_id: chapter.author.uid, bid: chapter.bid },
            }"
            >更多&gt;</router-link
          >
        </p>
        <div
          class="author-content"
          :style="authorLineStyle"
          v-if="chapter.author.uid && chapter.author.authorSay"
        >
          <img :src="chapter.author.avatar || '../assets/1.png'" alt="" />
          <div class="author-info">
            <p class="author-name" :style="authorColorStyle">
              <span class="names">{{ chapter.author.nickname }}</span>
              <img
                :src="getAuthorLevel(chapter.author.authorLevel)"
                class="author-icon"
              />
            </p>
            <p
              class="author-intro"
              :style="authorColorStyle"
              v-html="chapter.author.authorSay"
            ></p>
          </div>
        </div>
        <div class="author-operator">
          <!-- <p class="operator-item"
             :style="authorHandleStyle">送礼物<span>{{chapter.porps}}人</span></p> -->
          <p
            class="operator-item"
            :style="[authorHandleStyle, authorColorStyle]"
            @click.stop="showPopup(1)"
          >
            投月票<span :style="authorColorStyle"
              >{{ chapter.bookData.monthTickets }}票</span
            >
            <i v-if="chapter.userTicket">{{ chapter.userTicket }}</i>
          </p>
          <p
            class="operator-item"
            :style="[authorHandleStyle, authorColorStyle]"
            @click.stop="showPopup(2)"
          >
            投推荐票<span :style="authorColorStyle"
              >{{ chapter.bookData.recommendTickets }}票</span
            >
            <i v-if="chapter.userRecomm">{{ chapter.userRecomm }}</i>
          </p>
          <router-link
            tag="p"
            :to="{
              name: commentPage,
              params: { type: 'reader' },
              query: { type: 1, bid: chapterInfo.bid, cid: chapterInfo.cid },
            }"
            :style="[authorHandleStyle, authorColorStyle]"
            class="operator-item"
            >评论<span :style="authorColorStyle"
              >{{ chapter.bookData.comments }}条</span
            ></router-link
          >
        </div>
      </div>
    </div>

    <!-- 收藏遮罩层 -->
    <template v-if="showWechatCollection">
      <div class="collection_wrap" @click="showWechatCollection = false">
        <img
          :src="isAndroid ? wechat_float.android_img : wechat_float.ios_img"
          alt=""
        />
      </div>
    </template>

    <!-- 浮动红包 -->
    <template v-if="hasRed">
      <div class="float-red-entry" @click="openRed">
        <img src="../assets/current-red-tag.gif" alt="" />
      </div>
    </template>
    <!-- app下载入口 -->
    <template v-if="app_download.show">
      <div class="fixed-app-download-guide">
        <a :href="app_download.link">
          <img :src="app_download.float_entry" alt="" />
        </a>
      </div>
    </template>
  </x-page>
</template>

<script>
/* eslint-disable */
import ReaderOptions from "./options/reader.js";
import { getAuthorLevel } from "../utils/getlevel.js";

import { reader } from "@/mixin/reader";
import { helpMethods } from "@/mixin/help.js";
import { ReaderErr, PopupErr } from "@/mixin/err.js";
import { fetchReset } from "@/mixin/fetchRest.js";

import {
  Comment,
  BookReader,
  BookCatalog,
  Detail,
  lastPage,
  // Pay,
  AuthorSay,
  // BookRank
} from "./index.js";

import { getChapterContent, buyBookOrChapter, addBookCase } from "@/api";

import { SendGift } from "@/components/popup";
import {
  ReaderAward,
  FiveOneActivity,
  RedPackStatus,
} from "@/components/dialog";

export default {
  mixins: [reader, fetchReset, helpMethods, ReaderErr, PopupErr],
  data() {
    return {
      init: false,
      showBgChoose: false,
      weakSubscribe: false,
      showWechatCollection: false,
      commentPage: Comment.name,
      detailPage: Detail.name,
      AuthorSay: AuthorSay.name,
      options: ReaderOptions,
      chapter: {},
      routerName: "",
      weakText: [],
      activityKey: 0,
      activity: window.ycsd.activity_position.reader_banner,
      guide_personal_account: window.ycsd.guide_personal_account,
      wechat_float: window.ycsd.wechat_float,
      app_download: window.ycsd.down_app_float,
      is_access_read: true,
    };
  },
  computed: {
    chapterInfo() {
      return this.chapter.chapter || this.chapter;
    },
    content() {
      // * 章节内容正则替换
      return this.chapter
        ? this.chapter.content
            .replace(/(\<br\s?\/\>)+/g, "#@#")
            .replace(/(&nbsp;)/g, "")
            .replace(/(\")/g, "")
            .split("#@#")
        : [];
    },
    ABanner() {
      return this.activity[this.activityKey];
    },
    isAndroid() {
      let u = navigator.userAgent;
      return u.indexOf("iPhone") === -1;
    },
    redInfo() {
      return this.chapterInfo.redPackInfo;
    },
    hasNextRed() {
      return this.redInfo.nextPackId;
    },
    hasRed() {
      return this.redInfo ? this.redInfo.currentPackId : "";
    },
  },
  methods: {
    getContent(bid, cid, page_from) {
      /**
       * 错误码处理
       * 10016 单章购买
       * 10017 单本购买
       * 10015 单章购买余额不足
       * 10014 单本购买余额不足
       * 10012 未关注
       * 10006 包月已购买
       * 10007 包月订购结束
       * 10008 包月可购买
       * 10009 包月已失效
       * 10010 章节已反馈
       * 10011 章节纠错次数达上限
       * 20002 章节审核未通过（不存在） - 跳转至目录页
       */
      this.$toast({
        type: "loading",
        message: "努力加载ing",
        forbidClick: true,
        duration: 0,
      });
      return getChapterContent(bid, cid, page_from)
        .catch((e) => {
          // TODO 错误集合
          console.log(e);
          this.$toast.clear();
          // this.chapter = e.data;
          // this.readerErrHandle(e.code, e.data);
          return Promise.reject(e);
        })
        .then((r) => {
          this.is_access_read = r.is_access_read == 1 ? true : false;
          this.chapter = r;
          // * 弱关
          this.weakSubscribe = r.showSubLink;
          this.weakText = r.subTitle;
          this.$toast.clear();
          document.body.scrollTop = 0;
          if (!this.init) this.init = true;
          this.getDataResetDom();
          // 随机banner
          this.getRandomABannerKey();
          if (!this.is_access_read) {
            this.$router.push({ name: "TeenAgersLock" });
          }

          // 阅读器满足字数条件弹窗
          if (r.activity.subscribe.show)
            ReaderAward({ info: r.activity.subscribe }).catch((e) => {
              console.log(e);
            });
          // 活动满足条件就弹窗
          if (r.activity.subCoin.show)
            FiveOneActivity({ global: r.activity.subCoin });
          // 经验值展示
          if (r.integration && !r.from_cache) {
            this.$notify({
              message: `订阅成功 +${r.integration}经验值`,
              background: "rgba(0, 0, 0, .4)",
            });
          }
          return r;
        });
    },
    prevChapter() {
      // * 上一章
      let chapter = this.chapter;
      if (chapter.prevId !== "0") {
        this.$router.replace({
          name: BookReader.name,
          params: {
            bid: chapter.bid,
            chapter_id: chapter.prevId,
          },
        });
      } else this.$toast("喂喂喂，当前已是第一章了！");
    },
    nextChapter() {
      // * 下一章
      let chapter = this.chapter;
      if (chapter.nextId !== "0") {
        this.$router.replace({
          name: BookReader.name,
          params: {
            bid: chapter.bid,
            chapter_id: chapter.nextId,
          },
        });
      } else {
        // TODO 最后一章了 跳转到推荐页或者其他页
        this.$router.push({
          name: lastPage.name,
          params: {
            bid: chapter.bid,
          },
        });
      }
    },
    readerBuyHandle(type, data) {
      // * 阅读器购买内容 （包括章节和全本）
      // * type - 购买类型 1-章节 2-全本
      console.log(data);
      let params = {
        bid: data.bid,
        cid: data.cid,
      };
      buyBookOrChapter(params)
        .then(() => {
          // * 购买成功
          this.$toast("购买成功！");
          // * 重新请求章节内容
          this.getContent(this.bid, this.cid);
        })
        .catch((e) => {
          this.$toast(e.msg);
        });
    },
    addToShelf() {
      // * 加入书架
      addBookCase(this.chapterInfo.bid, this.chapterInfo.id)
        .then(() => {
          this.$toast("加入书架成功！");
          this.chapter.isAddBookShelf = true;
        })
        .catch((e) => {
          this.$toast(e.msg);
        });
    },
    menuOperator(e) {
      let clickTarget = e.target.classList[1];
      switch (clickTarget) {
        case "x-reader__menu--prev":
          this.prevChapter();
          break;
        case "x-reader__menu--next":
          this.nextChapter();
          break;
        case "x-reader__menu--catalog":
          this.toCatalog();
          break;
      }
    },
    toCatalog() {
      this.$router.push({
        name: BookCatalog.name,
        params: { bid: this.chapterInfo.bid },
        query: {
          cid: this.chapterInfo.id,
          order: this.chapterInfo.sequence,
        },
      });
    },
    showPopup(index) {
      // * 显示送礼/月票/推荐票的弹窗
      SendGift({
        bid: this.chapterInfo.bid,
        curSwiperIndex: index || 0,
        is_vip: this.chapter.showMonthVote,
      })
        .then((r) => {
          // 操作成功的后续操作
          const { result, type } = r;
          this.handlerAfterSend(r.status, { result, type });
        })
        .catch((e) => {
          if (e.result) {
            const { result, type } = e;
            this.handlerAfterSend(e.status, { result, type });
          } else this.giftErr(e, this.chapterInfo, true);
        });
    },
    back() {
      location.href = `/detail/${this.chapterInfo.bid}`;
      // this.$router.push({
      //   name: this.detailPage,
      //   params: {
      //     bid: this.chapterInfo.bid
      //   }
      // });
    },
    toActivity(url) {
      location.href = url;
    },
    showRandomWeakText() {
      let weak_text = this.weakText;
      return weak_text[Math.floor(Math.random() * weak_text.length)];
    },
    getRandomABannerKey() {
      let banner_len = this.activity.length;
      let key = 0;
      if (banner_len) {
        let random = Math.ceil(Math.random() * banner_len);
        key = random - 1;
      } else key = banner_len;
      this.activityKey = key;
    },
    guideEntry(from) {
      console.log(this.guide_personal_account.link + "&p_src=" + from);
      if (this.guide_personal_account.link) {
        location.href = this.guide_personal_account.link + "&p_src=" + from;
      }
    },
    openRed() {
      const { author } = this.chapterInfo;
      RedPackStatus({
        avatar: author.avatar,
        nickname: author.nickname,
        pack_id: this.hasRed,
        router: this.$router,
      }).catch((e) => {
        e && this.$toast(e.msg);
      });
    },
    getAuthorLevel,
  },
  created() {
    // this.bid = this.$route.params.bid;
    // this.cid = this.$route.params.chapter_id;
    // this.getContent(this.bid, this.cid).catch(e => {
    //   this.readerErrHandle(e.code, e.data);
    // });
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let page_from = null;
      vm.routerName = from.name;
      vm.routerName === "catalog" && (page_from = "chapter_dir");
      vm.bid = to.params.bid;
      vm.cid = to.params.chapter_id;
      vm.getContent(vm.bid, vm.cid, page_from).catch((e) => {
        vm.readerErrHandle(e.code, e.data);
      });
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.bid = to.params.bid;
    this.cid = to.params.chapter_id;
    let page_from = "chapter_info";
    this.getContent(this.bid, this.cid, page_from)
      .then((r) => {
        next();
      })
      .catch((e) => {
        this.readerErrHandle(e.code, e.data);
      });
  },
};
</script>
